import {
  Color,
  COLOR_SCHEMA_DARK,
  COLOR_SCHEMA_DARK_LIGHT,
  COLOR_SCHEMA_LIGHT,
  FontSize,
  FontWeight,
} from '../../../typings/design-tokens';

import { MATCH_CHANGE_TYPE_HP } from './match-change-hp';
import { MATCH_CHANGE_TYPE_LMP } from './match-change-lmp';

// COLORS/FONTS for all VARIANTS
export const DEFAULT_COLOR: Color = 'light';
export const DEFAULT_FONT_SIZE: FontSize = '14';
export const DEFAULT_FONT_WEIGHT: FontWeight = '400';
export const COLOR_WITH_SCHEMA_DARK: Color = 'light';
export const COLOR_WITH_SCHEMA_LIGHT: Color = 'blue';

export const colorSchemaMapping = {
  [COLOR_SCHEMA_DARK]: COLOR_WITH_SCHEMA_DARK,
  [COLOR_SCHEMA_DARK_LIGHT]: COLOR_WITH_SCHEMA_DARK,
  [COLOR_SCHEMA_LIGHT]: COLOR_WITH_SCHEMA_LIGHT,
};

// COMBINE all VARIANTS exported from MATCH CHANGE COMPONENTS
export const MatchChangeVariantList: MatchChangeVariant[] = [MATCH_CHANGE_TYPE_LMP, MATCH_CHANGE_TYPE_HP];
export type MatchChangeVariant = typeof MATCH_CHANGE_TYPE_LMP | typeof MATCH_CHANGE_TYPE_HP;
